import { NavLink } from 'react-router-dom';
import { Breadcrumbs as UiBreadcrumb } from '@paysera/ui';
import { useTranslation } from 'react-i18next';
import { BREADCRUMB_IDS } from '@app/configs/breadcrumbs';
import { ROUTES } from '@app/configs/routes';
const Breadcrumbs = ({ items = [], activeBreadcrumb, type }) => {
    const { t } = useTranslation();
    const rootItem = {
        borrower: { id: BREADCRUMB_IDS.BORROWER, label: t('financing.breadcrumbs.borrowing'), path: ROUTES.home },
        investor: { id: BREADCRUMB_IDS.INVESTOR, label: t('financing.breadcrumbs.investing'), path: ROUTES.home },
    };
    const allItems = [rootItem[type], ...items];
    return <UiBreadcrumb items={allItems} activeBreadcrumb={activeBreadcrumb} linkAs={NavLink}/>;
};
export default Breadcrumbs;
